

<template>
  <div class="newsWarp h100">
    <div class="newLeft" @click="goNewsDetail(newsObj.one)">
      <img class="newLeftImage" src="../../assets/image/new_one_bg.png" alt="">
      <div class="newInfo">
        <div class="newInfoTitle fOH">
          {{newsObj.one.title}}
        </div>
        <div class="newInfoTime fOH">
          {{newsObj.one.time}}
        </div>
      </div>
    </div>
    <div class="newRight">
      <div class="homeAtrList">
        <div class="homeAtrItem" v-for="(v,i) in newsObj.two" :key="v.id" @click="goNewsDetail(v)">
          <div class="atrTitle fOH">{{ v.title }}</div>
          <div class="atrDesc fOH">{{ v.time }}</div>
        </div>
      </div>

    </div>
    <div class="newsMoreBtn">
      <div class="newsMoreBtnItem fAm" @click="goNew">Learn More</div>
    </div>
  </div>
</template>
<script>
export default {
  computed:{
    newsObj(){
      return this.$store.getters.homeData.newsObj;
    }
  },
  methods:{
    goNew(){
      this.$router.push({name:"News"})
    },
    async goNewsDetail(v){
      if(v.id){
        await this.$store.dispatch('setStoreByKeyData', {key: 'setNewsInfo', data: v})
        this.$router.push({name:"NewsDetail",query:{id:v.id}})
      }
    }
  }
}
</script>
<style scoped lang="scss">
  .newsWarp{
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    .newLeft{
      position: relative;
      margin-top: 1rem;
      .newInfo{
        cursor: pointer;
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        z-index: 10;
        display: flex;
        padding: 1rem;
        box-sizing: border-box;
        align-items: flex-start;
        justify-content: space-between;
        flex-direction: column;
        .newInfoTitle{
          color: #fff;
          line-height: 1.3rem;
          font-size: .8rem;
        }
        .newInfoTime{
          color: #8FCADD;
          font-size: .75rem;
        }
      }
      .newLeftImage{
        width: 100%;
      }
    }
    .newRight{
      flex: 1;
      display: flex;
      justify-content: space-between;
      flex-direction: column;
      position: relative;
      overflow: hidden;
      background: linear-gradient(to bottom, rgba(255, 255, 255, 1) 80%, rgba(255, 255, 255, 0));
      background-clip: text;
      -webkit-background-clip: text;
      text-fill-color: transparent;
      -webkit-text-fill-color: transparent;
      .homeAtrList{
        .homeAtrItem:first-child {
          //padding-top: 0 !important;
        }
        .homeAtrItem{
          border-bottom: .12rem solid rgba(255,255,255,.6);
          padding: 1rem 0;
          .atrTitle{
            font-size: .8rem;
            color: #fff;
            line-height: 1.3rem;
          }
          .atrDesc{
            font-size: .7rem;
            margin-top: .5rem;
            color: #8FCADD;
          }

        }
      }
    }
  }
  .newsMoreBtn{
    display: flex;
    padding: 1rem 0;
    //margin-top: .5rem;
    justify-content: center;
    width: 100%;
    background: transparent;
    //background: linear-gradient(0deg, transparent 0%, #fff 50%);
    .newsMoreBtnItem{
      padding: .8rem 0;
      border: .05rem solid #fff;
      width: 10rem;
      font-size: .8rem;
      display: flex;
      align-items: center;
      color: #fff;
      justify-content: center;
    }
  }
</style>
